import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  Email,
  Phone,
  LocationOn,
} from '@mui/icons-material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        color: '#ffffff',
        py: 3,
        mt: 'auto',
        backgroundColor: '#1F2937', // Dark gray color matching navbar
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} alignItems="center">
          {/* CSE Logo */}
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src="/logobg.png"
              alt="CSE Department Logo"
              sx={{
                height: 200,
                width: 'auto',
                display: 'block',
                margin: '0 auto',
                filter: 'brightness(0) invert(1)',
                maxWidth: '100%'
              }}
            />
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#ffffff' }}>
                Department of Computer Science and Engineering
              </Typography>
              <Typography variant="subtitle2" gutterBottom sx={{ color: '#ffffff' }}>
                MBM University, Jodhpur
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mt: 1 }}>
                <Phone sx={{ fontSize: '1rem', color: '#ffffff' }} />
                <Typography variant="body2" sx={{ color: '#ffffff' }}>+91 123 456 7890</Typography>
                <Email sx={{ fontSize: '1rem', ml: 2, color: '#ffffff' }} />
                <Typography variant="body2" sx={{ color: '#ffffff' }}>cse@mbm.ac.in</Typography>
              </Box>
            </Box>
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <IconButton sx={{ color: '#ffffff' }} aria-label="Facebook">
                <Facebook />
              </IconButton>
              <IconButton sx={{ color: '#ffffff' }} aria-label="Twitter">
                <Twitter />
              </IconButton>
              <IconButton sx={{ color: '#ffffff' }} aria-label="Instagram">
                <Instagram />
              </IconButton>
            <a href="https://www.linkedin.com/company/cse-at-mbm-university" target="_blank" rel="noopener noreferrer">
              <IconButton sx={{ color: '#ffffff' }} aria-label="LinkedIn">
                <LinkedIn />
              </IconButton>
            </a>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.2)' }} />

        <Typography variant="body2" align="center" sx={{ color: '#ffffff', opacity: 0.9 }}>
          © {new Date().getFullYear()} Department of Computer Science and Engineering, MBM University. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 
